import PositionalMediaButton from './PositionalMediaButton'

export default PositionalMediaButton
